<template>
  <div class="container  mt-3">
    <div class="m-auto">
    	
      <div class="form-horizontal">
        <div class="form-group row" v-if="estudiante">
          <label class="col-12 col-sm-4 col-form-label">Versant</label>
          <div class="col-12 col-sm-4">
            <select v-model="versant" class="form-control">
              <option disabled value="">Please select one</option>
              <option  value="1">Es Versant</option>
              <option  value="0">No es Versant</option>
            </select>
          </div>
          <div class="col-12 col-sm-4">
              <button v-if="procesable" class="btn btn-block btn-danger" @click="procesar">
                Guardar
              </button>
            </div> 
        </div>
        <div v-else>
          No hay cursos inscritos
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'DetalleVersant',
    data () {
      return {
        versant:null
      }
    },
    props: {
      estudiante: Object
    },
    mounted () {
      if(this.estudiante){
        this.versant = this.estudiante.versant
      }
    },
    methods:{
      ...mapActions({
        editarVersant: 'estudiantes/editarVersant',
        fetchDetalle: 'estudiantes/fetchDetalle',
        setWarning: 'setWarning',
      }),
      ...mapMutations({
        
      }),
      procesar(){
        this.editarVersant({
          id:this.estudiante.id,
          versant:this.versant,
          
        }).then((apiResponse)=>{
          
          this.limpiar()
          this.setWarning('Información Guardada', { root: true }).then(()=>{
            this.fetchDetalle(this.estudiante.id).then(()=>{
              this.versant = this.estudiante.versant
              // this.$router.push('/estudiante/detalle/'+this.estudiante.id)
            }) 
          })
          
        }).catch((apiResponse)=>{
          console.log("error procesando editar versant.")
        })
      },
      limpiar(){
       this.versant  = null
      }
    },
    computed:{
      ...mapState({
        
      }),
      ...mapGetters({
        
      }),
      procesable: {
        get () {
          return (this.versant != null && this.versant!=this.estudiante.versant)
        },
        set(value){}
      },
    }
  }
</script>

<style scope>
  .programar_wrapper .form-container{
      
  }
	.programar_wrapper{
    
	}
</style>

